module.exports = __webpack_public_path__ + "media/images/lb/629-ba0af225a217049d3f90fb88ae8e4602.svg";